import BaseService from './base.service';

/**
 * Service for handling encrypted token authentication from external applications
 */
export default class TokenAuthService extends BaseService {
  /**
   * Validate and authenticate using an encrypted token
   * @param {string} encryptedToken - URL-safe Base64 encrypted token
   * @returns {Promise<Object>} Decrypted token data with user information
   */
  async validateEncryptedToken(encryptedToken) {
    return this.post('auth/validate-encrypted-token', { encryptedToken });
  }

  /**
   * Extract token from URL parameters
   * @returns {string|null} Encrypted token from URL or null if not found
   */
  getTokenFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('authToken');
  }

  /**
   * Clean token parameter from URL without page reload
   */
  cleanTokenFromUrl() {
    const url = new URL(window.location);
    url.searchParams.delete('authToken');
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }

  /**
   * Check if token is expired
   * @param {Object} tokenData - Decrypted token data
   * @returns {boolean} True if token is expired
   */
  isTokenExpired(tokenData) {
    if (!tokenData.exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > tokenData.exp;
  }
}
